import { useEffect } from 'react'

import { useAiChat } from '@factorialco/f0-react/dist/experimental'

import { initialSurveyPrompt } from 'modules/engagement_surveys/activities/CreateSurvey/prompt'

type UseAutoOpenChatParams = {
  shouldAutoOpen?: boolean
  placeholders?: string[]
}

export const useAutoOpenChat = (
  { shouldAutoOpen, placeholders }: UseAutoOpenChatParams = { shouldAutoOpen: true }
) => {
  const { open, setOpen, setPlaceholders, sendMessage } = useAiChat()

  useEffect(() => {
    if (!shouldAutoOpen) return

    const initiallyOpen = open

    if (!initiallyOpen) {
      setOpen(true)
      setPlaceholders(placeholders || [])
      if (initialSurveyPrompt.current) {
        sendMessage(initialSurveyPrompt.current)
      }
    }

    return () => {
      if (!initiallyOpen) {
        setOpen(false)
      }
    }
  }, [shouldAutoOpen])
}
